export default __webpack_public_path__ + "static/media/square-lg.795e4121.svg";